import { message, Upload } from "antd"
import styles from "./index.module.scss"
import { useContext, useEffect } from "react"
import Utils from '@utils/utils';
import { useNavigate, useParams } from "react-router-dom";
import API, { commonApiInvoker } from "@api/api";
import { SERVICE_OPTIONS } from '@utils/CONST'
import UploadBox from "../components/UploadBox";
import { BatchImagesContext } from "../BatchImagesContext.js";
import GoBack from "../components/GoBack";


export default function UploadPage() {
    const { setProjectType, setFileList } = useContext(BatchImagesContext)
    const navigate = useNavigate()
    const { projectType } = useParams()

    useEffect(() => {
        setFileList([])
    }, [])

    const handleUpload = async (file, fileList) => {
        try {
            // 需要登录
            const status = Utils.checkLoginStatus(() => null)
            if (!status) return

            if (fileList.length == 0) return
            setFileList(fileList)
            setProjectType(projectType)
            API.addProject({
                projectType: projectType,
            }).then(res => {
                if (res?.code != 0) throw new Error(res.message)
                if (res?.data?.id) {
                    navigate(`/home/product/${res?.data?.id}/config`)
                }
            }).catch(err => message.error(err.message))

        } catch (err) {
            console.error(err.message)
        }
    }

    return (
        <>
            <div className={styles.UploadPage}>
                <div className={styles.Content}>
                    <div className={styles.GoBack}>
                        <GoBack onClick={() => navigate("/home/product/batchImages")} />
                    </div>
                    <UploadBox
                        projectType={projectType}
                        onUpload={handleUpload}
                    />
                </div>
            </div>

        </>

    )
}